module.exports = require("@swa-ui/dotcom/src/LocaleSwitcher/LocaleSwitcher.module.scss");